import React from 'react';
import styles from './AnnouncementTicker.module.css';

const AnnouncementTicker = () => {
  const content = (
    <>
      <span className={styles.icon}>📢</span>
      <span className={styles.text}>15-25 કે તેથી વધુ વ્યક્તિઓ માટે ફુડની હોમ ડીલીવરી આપીશું.</span>
      <span className={styles.separator}>•</span>
      <span className={styles.icon}>📢</span>
      <span className={styles.text}>તાજી અને ઘરની રીતથી બનાવેલી તમામ વાનગીઓ ઉપલબ્ધ.</span>
      <span className={styles.separator}>•</span>
       <span className={styles.icon}>📢</span>
      <span className={styles.text}>15-25 કે તેથી વધુ વ્યક્તિઓ માટે ફુડની હોમ ડીલીવરી આપીશું.</span>
      <span className={styles.separator}>•</span>
      <span className={styles.icon}>📢</span>
      <span className={styles.text}>જન્મદિવસ, ઓફિસ પાર્ટી અને નાના ઇવેન્ટ માટે ખાસ મેનુ પણ મળશે.</span>
      <span className={styles.separator}>•</span>
     
    </>
  );

  return (
    <div className={styles.tickerWrapper}>
      <div className={styles.ticker}>
        <div className={styles.tickerContent}>
          {content}
          {content}
        </div>
      </div>
    </div>
  );
};

export default AnnouncementTicker;
